import { store } from "@store/store";
import { updatePropsAction } from "@actions/updateProps";

export const ConditionalGoBack = (args: any) => {
  const { layoutIds } = args || {};
  const state = store?.getState();
  const normalisedConfig = state?.configuration?.normalisedConfig;

  if (layoutIds?.length > 1) {
    layoutIds?.slice(1).forEach((layoutId: any) => {
      const currentLayoutId = layoutId;
      const currentLayoutVisible =
        normalisedConfig[layoutId]?.props?.is_visible === true;
      if (currentLayoutVisible) {
        const previousLayoutId = layoutIds[layoutIds.indexOf(layoutId) - 1];
        updatePropsAction({
          component_id: currentLayoutId,
          update_props: { is_visible: false }
        });
        updatePropsAction({
          component_id: previousLayoutId,
          update_props: { is_visible: true }
        });
      }
    });
  }
};
